import {Provider} from '@angular/core';
import {ReportDatepickerActionCoordinator} from './report-datepicker-action.coordinator';
import {ReportDatepickerDateCoordinator} from './report-datepicker-date.coordinator';
import {ReportDatepickerDepartmentLoader} from './report-datepicker-department.loader';
import {ReportDatepickerGroupReportCoordinator} from './report-datepicker-group-report.coordinator';
import {ReportDatepickerPersonalReportCoordinator} from './report-datepicker-personal-report.coordinator';
import {ReportDatepickerPlatform} from './report-datepicker.platform';
import {ReportDatepickerReportCoordinator} from './report-datepicker-report.coordinator';
import {ReportDatepickerReportPresenter} from './report-datepicker-report.presenter';
import {ReportDatepickerShiftCoordinator} from './report-datepicker-shift.coordinator';
import {ReportDatepickerSpecialRequestCoordinator} from './report-datepicker-special-request.coordinator';
import {ReportDatepickerStandardRequestCoordinator} from './report-datepicker-standard-request.coordinator';
import {ReportDatepickerVacationCoordinator} from './report-datepicker-vacation.coordinator';
import {ReportDatepickerVectorReportCoordinator} from './report-datepicker-vector-report.coordinator';
import {ReportDatepickerUiGateway} from './report-datepicker-ui.gateway';
import {ReportProgressCoordinator} from './report-progress.coordinator';
import {ReportProgressState} from './report-progress.state';

export const REPORT_DATEPICKER_PROVIDERS: Provider[] = [
  ReportDatepickerActionCoordinator,
  ReportDatepickerDateCoordinator,
  ReportDatepickerDepartmentLoader,
  ReportDatepickerGroupReportCoordinator,
  ReportDatepickerPersonalReportCoordinator,
  ReportDatepickerPlatform,
  ReportDatepickerReportCoordinator,
  ReportDatepickerReportPresenter,
  ReportDatepickerShiftCoordinator,
  ReportDatepickerSpecialRequestCoordinator,
  ReportDatepickerStandardRequestCoordinator,
  ReportDatepickerVacationCoordinator,
  ReportDatepickerVectorReportCoordinator,
  ReportDatepickerUiGateway,
  ReportProgressCoordinator,
  ReportProgressState
];



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/modals/report-datepicker.providers.ts